import React from "react";
import { IconButton } from "@mui/material";
import CustomIcon from "../../../../../Components/CustomIcon";



const TableIconView = ({ config, record }) => {
    const icon = config?.icon;
    const onClick = config?.onClick || (() => { });
    return (
        <IconButton onClick={() => onClick(record, config)}>
            <CustomIcon name={icon} />
        </IconButton>
    );
};

export default TableIconView
